"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const NotAllowedIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-305.000000, -344.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(301.000000, 340.000000)",
        fill: color,
        fillRule: "nonzero",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M22.8663604,9.49995157 C22.8378071,9.5493937 22.8047024,9.59686115 22.7670695,9.64172965 L22.6804511,9.73279349 L9.0041446,22.432221 C12.7283042,25.9260586 18.5805391,25.8544897 22.2175144,22.2175144 C25.6968777,18.7381512 25.9131597,13.2313691 22.8663604,9.49995157 Z M7.69492436,20.9186436 L21.3195489,8.26720651 C21.3757623,8.21500838 21.4363748,8.17051255 21.5000868,8.13367091 C17.7686687,5.08683883 12.2618608,5.30311038 8.78248558,8.78248558 C5.47972256,12.0852486 5.11720215,17.2148442 7.69492436,20.9186436 Z M23.631728,7.36827202 C28.1227573,11.8593014 28.1227573,19.1406986 23.631728,23.631728 C19.1406986,28.1227573 11.8593014,28.1227573 7.36827202,23.631728 C2.87724266,19.1406986 2.87724266,11.8593014 7.36827202,7.36827202 C11.8593014,2.87724266 19.1406986,2.87724266 23.631728,7.36827202 Z"
        })
      })
    })
  })]
});

NotAllowedIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = NotAllowedIcon;
exports.default = _default;